// The id of the bundle this page runs: scripts/build.js defines `__MO_BUILD__` and stamps the hash
// of its outputs in place of a placeholder. The server tells its own (SSE `hello`, bootstrap
// `office.build`, the X-Office-Build header); web/ui/updatenotice.js compares the two.

/** Same shape as the server's build ids (server/lib/buildinfo.js). */
export const BUILD_ID_RE = /^[0-9a-f]{16}$/;

// `typeof` never throws on an undeclared name: outside a bundle (node:test) this is null.
const raw = typeof __MO_BUILD__ === 'string' ? __MO_BUILD__ : null;

/** This page's build id, or null (tests, `--watch` builds, an unstamped bundle): no update check. */
export const CLIENT_BUILD = raw && BUILD_ID_RE.test(raw) ? raw : null;
